import type { DiagnosticAssignmentRow } from '@/api/adminDiagnostics'

/** 대표 배정: 활성(미완료·미취소) 우선, 없으면 최대 회차. useDiagnosticAssignments에서 추출. */
export function pickDiagnosticRep(rows: DiagnosticAssignmentRow[]): DiagnosticAssignmentRow | undefined {
  if (rows.length === 0) return undefined
  const active = rows.find((a) => a.status !== 'COMPLETED' && a.status !== 'CANCELLED')
  return active ?? rows.reduce((m, a) => (a.roundNo > m.roundNo ? a : m))
}
